import { render, staticRenderFns } from "./GoodsFormStep2.vue?vue&type=template&id=4cd21d48&scoped=true&"
import script from "./GoodsFormStep2.vue?vue&type=script&lang=js&"
export * from "./GoodsFormStep2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFormStep2.vue?vue&type=style&index=0&id=4cd21d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd21d48",
  null
  
)

export default component.exports